<template>
  <div
    v-if="version === 'v1'"
    class="tw-group tw-relative tw-col-span-12 tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-flex-col tw-justify-start tw-gap-0 tw-rounded tw-bg-white tw-text-start tw-text-black md:tw-col-span-6 lg:tw-col-span-4"
  >
    <div class="tw-relative">
      <LibraryPopupsVideoPopup v-if="guide.video" :videoUrl="guide.video" v-model:is-visible="isVisible" />
      <LibraryImage v-if="!guide.video" :src="guide.photo" :h-ratio="1.5" :w-ratio="1" image-class="tw-inset-0 tw-z-0" />
      <div @click="() => (isVisible = true)">
        <LibraryImage v-if="guide.video" :src="guide.photo" :h-ratio="1" :w-ratio="1.3" image-class="tw-inset-0 tw-z-0" />
      </div>

      <div
        @click="() => (isVisible = true)"
        class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
        v-if="guide.video"
      >
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M32 4C26.4621 4 21.0486 5.64217 16.444 8.71885C11.8395 11.7955 8.25064 16.1685 6.13139 21.2849C4.01213 26.4012 3.45764 32.0311 4.53802 37.4625C5.61841 42.894 8.28515 47.8831 12.201 51.799C16.1169 55.7149 21.106 58.3816 26.5375 59.462C31.969 60.5424 37.5988 59.9879 42.7151 57.8686C47.8315 55.7494 52.2045 52.1605 55.2812 47.556C58.3578 42.9514 60 37.5379 60 32C60 24.5739 57.05 17.452 51.799 12.201C46.548 6.94999 39.4261 4 32 4ZM46.894 33.79L22.894 45.79C22.589 45.9424 22.2501 46.0143 21.9095 45.9989C21.5689 45.9835 21.2379 45.8812 20.948 45.7019C20.658 45.5225 20.4187 45.272 20.2528 44.9741C20.0869 44.6763 19.9999 44.341 20 44V20C20.0002 19.6592 20.0875 19.3241 20.2535 19.0265C20.4196 18.729 20.6589 18.4787 20.9488 18.2996C21.2387 18.1205 21.5696 18.0184 21.91 18.0031C22.2505 17.9878 22.5892 18.0597 22.894 18.212L46.894 30.212C47.2258 30.3783 47.5047 30.6336 47.6997 30.9494C47.8946 31.2651 47.9979 31.6289 47.9979 32C47.9979 32.3711 47.8946 32.7349 47.6997 33.0507C47.5047 33.3664 47.2258 33.6217 46.894 33.788"
            fill="white"
          />
        </svg>
      </div>

      <!-- <div
        v-if="!guide.video"
        class="tw-absolute tw-inset-0 tw-flex tw-flex-col-reverse tw-items-center tw-bg-[--c-primary] tw-text-white tw-opacity-0 tw-duration-500 group-hover:tw-opacity-80"
      ></div> -->
      <div
        v-if="!guide.video"
        class="tw-absolute tw-inset-0 tw-flex tw-flex-row tw-items-end tw-justify-center tw-text-white tw-opacity-0 tw-duration-500 group-hover:tw-opacity-100"
      >
        <button
          v-if="!guide.hover_button_link"
          class="tw-mb-4"
          @click="() => (isVisible = true)"
          :class="`n-${guide.hover_button_type}`"
        >
          <h5>
            {{ guide.hover_button_label }}
          </h5>
        </button>
        <nuxt-link
          v-else
          :to="guide.hover_button_link"
          :external="true"
          class="tw-mb-4"
          :class="`n-${guide.hover_button_type}`"
        >
          <h5>
            {{ guide.hover_button_label }}
          </h5>
        </nuxt-link>
      </div>
    </div>
    <div
      v-if="guide.video"
      @click="() => (isVisible = true)"
      class="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-start tw-gap-4 tw-p-6 tw-text-center"
    >
      <div>
        <span>{{ guide.type }}</span>
        <h4 class="tw-line-clamp-3 tw-min-h-[100px]">{{ guide.title }}</h4>
      </div>
      <nuxt-link
        v-if="!guide.hover_button_link"
        :to="guide.button_link"
        :external="true"
        :class="`n-${guide.button_type} tw-mt-auto`"
        style="color: var(--c-primary)"
      >
        <!-- FIXME buranın hover ına -->
        <h5>{{ guide.button_label }}</h5>
      </nuxt-link>
    </div>

    <div v-else class="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-start tw-gap-4 tw-p-6 tw-text-center">
      <div>
        <span>{{ guide.type }}</span>
        <h4 class="tw-line-clamp-3 tw-min-h-[100px]">{{ guide.title }}</h4>
      </div>
      <nuxt-link
        v-if="!guide.hover_button_link"
        :to="guide.button_link"
        :external="true"
        :class="`n-${guide.button_type} tw-mt-auto`"
        style="color: var(--c-primary)"
      >
        <!-- FIXME buranın hover ına -->
        <h5>{{ guide.button_label }}</h5>
      </nuxt-link>

      <nuxt-link
        v-else
        :to="guide.button_link"
        :external="true"
        class="tw-mb-4"
        :class="`n-${guide.hover_button_type}`"
        style="color: var(--c-primary)"
      >
        <h5>
          {{ guide.hover_button_label }}
        </h5>
      </nuxt-link>
    </div>
  </div>

  <!-- VERSION V2 -->
  <div
    class="tw-col-span-12 tw-w-full tw-gap-4 tw-bg-white md:tw-col-span-6 lg:tw-col-span-4"
    :class="guide.type === 'E-Guide' ? 'xl:tw-col-span-3' : ''"
    style="border-radius: var(--rounded)"
    v-else-if="version === 'v2'"
  >
    <template v-if="guide.type === 'E-Guide'">
      <div
        class="n-card tw-group tw-relative tw-flex tw-min-h-[600px] tw-w-full tw-cursor-pointer tw-flex-col tw-overflow-hidden tw-rounded-[var(--c-rounded)] tw-bg-white tw-text-start tw-transition-all tw-duration-500 hover:tw-bg-[var(--c-input)]"
        @click="$emit('open-guide-popup')"
        style="border-radius: var(--rounded)"
      >
        <!-- Resim Alanı -->
        <div class="tw-relative">
          <div class="tw-relative tw-p-4">
            <library-image
              v-if="guide.photo"
              :src="guide.photo"
              :is-ratio-free="true"
              image-class="tw-h-full tw-w-full tw-object-cover"
              style="border-radius: var(--rounded)"
            />
          </div>
        </div>
        <!-- Kart Bilgi Alanı: Başlık ve Buton -->
        <div class="tw-flex tw-h-full tw-flex-col tw-items-start tw-justify-end tw-gap-4 tw-px-4 tw-py-6 tw-text-left">
          <h5 class="tw-mb-2 tw-line-clamp-2 tw-h-16 tw-overflow-hidden tw-text-[--c-secondary]">
            {{ guide.title }}
          </h5>
          <nuxt-link
            :to="guide.button_link ? guide.button_link : ''"
            :external="true"
            target="_blank"
            class="n-secondary n-link"
            @click.prevent="!guide.button_link && $emit('open-guide-popup')"
          >
            VIEW THIS GUIDE
          </nuxt-link>
        </div>
      </div>
    </template>

    <template v-else-if="guide.type === 'VIDEO' || guide.type === 'Video FAQ'">
      <div class="tw-flex tw-flex-col tw-gap-4 tw-p-3 tw-pb-4">
        <LibraryIframe :src="guide.video" />
        <h5 class="n-title-primary">{{ guide.title }}</h5>
        <nuxt-link :to="guide.button_link" :external="true" class="n-link" style="color: var(--c-primary)">{{
          guide.button_label
        }}</nuxt-link>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme5GuideCard',

  mixins: [ComponentMixin],

  props: {
    guide: {
      type: Object,
      required: true,
    },
    version: {
      type: String,
      required: false,
      default: 'v1',
    },
  },

  emits: ['open-guide-popup', 'click'],

  data() {
    return {
      isVisible: false,
      selectedGuide: null,
      form: null,
      popupConfig: {
        isActive: false,
      },
    };
  },
});
</script>

<style scoped>
/* Add any v2-specific styles here if needed */
</style>
